export type DdTemplateKind = 'standard' | 'custom';

/** True when custom DD template type must not be selected (LP tier or missing GP DD add-on). */
export function isDdCustomTemplateTypeDisabled(
  isLpCustomTemplateLocked: boolean,
  isGpCustomTemplateLocked: boolean,
  kind: DdTemplateKind | null | undefined,
): boolean {
  return (!!isLpCustomTemplateLocked || !!isGpCustomTemplateLocked) && kind === 'custom';
}

/** Clears custom selection when tier/add-on lock applies (storage restore, tier change). */
export function coerceDdTemplateTypeForTierLock(
  isLpCustomTemplateLocked: boolean,
  isGpCustomTemplateLocked: boolean,
  kind: DdTemplateKind | null,
): DdTemplateKind | null {
  return isDdCustomTemplateTypeDisabled(isLpCustomTemplateLocked, isGpCustomTemplateLocked, kind)
    ? null
    : kind;
}
